import React, {useEffect, useState} from "react";

export default function useOutsideAlerter(setOpen : (b: boolean) => void) {
    const [isShown, setIsShown] = useState(true);
    const ref = React.createRef<HTMLUListElement>();
    // const ref = useRef<HTMLDivElement | HTMLUListElement>(null);

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (isShown &&  ref.current && !ref.current.contains(event.target)) {
                setIsShown(false)
                setOpen(false);
            } else setIsShown(true);
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);

    return {ref, isShown, setIsShown};
}
